var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mine-list-container"},_vm._l((_vm.dataArray),function(list,i){return _c('div',{key:i,staticClass:"mine-list"},_vm._l((list),function(item,j){return _c('main-list-cell',{key:j,attrs:{"model":item},on:{"onCellClick":_vm.onCellClick}})}),1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }